<template>
    <div id="landing-banner">
        <!--=====================================-->
        <!--=        Banner Area Start         =-->
        <!--=====================================-->
        <section class="banner banner-style-5">
            <div class="container p-5">
                <div class="row">
                    <div class="col-12">
                        <div class="banner-content">
                            <h1 class="subtitle white mb-0" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">Nuestras premisas.</h1>
                            <h1 class="white font-weight-100 text-wrap-balance" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
                                Impulsar el <span class="bold">desarrollo sostenible</span> requiere <span class="bold">movilizar capital,</span>
                                nosotros lo queremos <span class="bold">facilitar.</span>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "LandingBanner",
    components: {
        
    }
}

</script>

<style scoped>
.banner-style-5 {
    padding: 200px 40px 0;
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/banners/banner-estrategia.png");
}

.banner.banner-style-5::after {
    background-color: transparent;
}

</style>